import React from "react";
import ProductPageFilter from "../../Components/PageFilters/ProductPageFilter";
import {Grid} from "@mui/material";
// import IndicatorsCard from "./IndicatorsCard";
import ProductsList from "./ProductsList";
import Permission from "../../Components/Permission";
import SpedStatusHandler from "../Dashboard/SpedStatusHandler";

const Products: React.FC = () => {

    const [spedFiscalIdSelecionado, setSpedFiscalIdSelecionado] = React.useState<number | null>(null);

    return (<>
        <Grid container spacing={0.5}>
            <SpedStatusHandler
                onSpedFiscalIdChange={(id: number | null, dataInicio?: string, dataFim?: string) => {
                    setSpedFiscalIdSelecionado(id);
                }}
            />
            <ProductPageFilter />
            {/* <IndicatorsCard/> */}
            {/* <Permission accountProducts='CREDIT_DEBIT_CARD'> */}
                <ProductsList spedFiscalId={spedFiscalIdSelecionado} />
            {/* </Permission> */}
        </Grid>
    </>);
}

export default Products;
